import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-sale-not-found',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './sale-not-found.component.html',
    styleUrl: './sale-not-found.component.scss',
})
export class SaleNotFoundComponent {

}
